import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "fl label alertRedBorder mt2"
}
const _hoisted_4 = {
  key: 1,
  class: "fl label dblueBg mt2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "alertRed fl mb10"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "alertRed fl mb10"
}
const _hoisted_12 = { key: 3 }
const _hoisted_13 = ["for"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "fl mr17 mb6 mt5"
}
const _hoisted_16 = ["for"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "alertRed fl mb10"
}
const _hoisted_19 = {
  key: 4,
  class: "mt6"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "fl mr17 mb6 mt5"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "alertRed fl mb10"
}
const _hoisted_24 = { key: 5 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  class: /*#__PURE__*/_normalizeClass(`fl mr10`)
}
const _hoisted_27 = {
  class: /*#__PURE__*/_normalizeClass(`fl`)
}
const _hoisted_28 = ["id", "name", "checked"]
const _hoisted_29 = ["for"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = {
  key: 1,
  class: "alertRed fl mb10"
}
const _hoisted_32 = {
  key: 6,
  class: "mt6"
}
const _hoisted_33 = {
  key: 0,
  class: "text-left mb10"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "fl fs16 mt17 ml5 mr5" }, "年", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "fl fs16 mt17 ml5 mr5" }, "月", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "fl fs16 mt17 ml5 mr5" }, "日", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = {
  key: 1,
  class: "alertRed fl mb10"
}
const _hoisted_39 = { key: 7 }
const _hoisted_40 = { class: "mt10" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl mt15 mr20 fs13 text-left",
  style: {"width":"160px"}
}, "郵便番号(例:1000000)", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = { class: "mt10" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl mt15 mr20 fs13 text-left",
  style: {"width":"160px"}
}, "都道府県", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = { class: "mt10" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl mt15 mr20 fs13 text-left",
  style: {"width":"160px"}
}, "住所1（市区町村）", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = { class: "mt10" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl mt15 mr20 fs13 text-left",
  style: {"width":"160px"}
}, "住所2（マンションなど）", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = {
  key: 8,
  class: "mt20 mb20"
}
const _hoisted_53 = { class: "mt13 fs14 ddgrey text-left mb20 kaigyo" }
const _hoisted_54 = {
  key: 9,
  class: "mt20 mb20"
}
const _hoisted_55 = ["src"]
const _hoisted_56 = {
  key: 10,
  class: "mt20 mb20"
}
const _hoisted_57 = {
  key: 1,
  class: "centering pad5"
}
const _hoisted_58 = ["src"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_60 = {
  key: 2,
  class: "drop pad20"
}
const _hoisted_61 = {
  for: "uploadText",
  class: "fl skyblueBg rad8 pointer fw600 mr15 hoverGreyBg",
  style: {"padding":"8px 14px"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "drag-drop-info fl mt10" }, "または、ここにファイルをドロップ", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = {
  key: 0,
  class: "alertRed fl mb10"
}
const _hoisted_65 = {
  key: 11,
  class: "mt20 mb20"
}
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["src"]
const _hoisted_68 = ["src"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_70 = { class: "mt5 fs13" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_73 = {
  key: 0,
  class: "alertRed fl mb10"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_76 = {
  key: 0,
  class: "fl editArea",
  style: {"width":"200px"}
}
const _hoisted_77 = { class: "fl ml10" }
const _hoisted_78 = ["src"]
const _hoisted_79 = {
  key: 1,
  style: {"height":"24px"}
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_81 = ["src"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_83 = {
  class: "fl ml10",
  style: {"margin-top":"30px","width":"150px"}
}
const _hoisted_84 = { class: "centering" }
const _hoisted_85 = ["src", "id"]
const _hoisted_86 = {
  key: 1,
  style: {"width":"20px"},
  class: "fl mr15"
}
const _hoisted_87 = ["src"]
const _hoisted_88 = {
  key: 3,
  style: {"width":"20px"},
  class: "fl mr15"
}
const _hoisted_89 = ["src"]
const _hoisted_90 = {
  key: 5,
  style: {"width":"20px"},
  class: "fl mr15"
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_92 = { class: "fs11 mt5" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_RadioButtonTag = _resolveComponent("RadioButtonTag")!
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_UserFileImage = _resolveComponent("UserFileImage")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.field && _ctx.showField)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "fl",
            style: _normalizeStyle({
                    width: _ctx.editable ? `calc(100% - 200px)` : `100%`,
                })
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(`editableField ${_ctx.editable ? `withEditable` : ``} posRe`),
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.editField && _ctx.editField(...args)))
            }, [
              (!_ctx.field.field_type.includes(`head`))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("label", {
                      class: "fl fw600 ddgrey mb5 text-left",
                      style: _normalizeStyle(_ctx.fieldNameStyle())
                    }, _toDisplayString(_ctx.field.field_name) + "  ", 5),
                    (_ctx.field.is_required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(`title.required`)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.field.display_type != `normal`)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "隠された質問"))
                      : _createCommentVNode("", true),
                    _hoisted_5,
                    (_ctx.field.description)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 2,
                          class: "ddgrey text-left kaigyo",
                          style: _normalizeStyle(_ctx.fieldDescriptionStyle()),
                          innerHTML: 
                                _ctx.field.description
                                    .replace(/<[^>]*>?/gm, '')
                                    .replace(
                                        /(https?:\/\/[^\s]+)/g,
                                        '<a href="$1" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable">$1</a>'
                                    )
                            
                        }, null, 12, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_7,
              (_ctx.field.field_type == `input`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_TextfieldTag, {
                      placeholder: _ctx.field.placeholder_attr,
                      style: _normalizeStyle(_ctx.fieldInputStyle()),
                      class: _normalizeClass(`fl fs14 roundForm mw100 ${_ctx.field.isValid ? `` : `invalid`}`),
                      tabindex: _ctx.fieldindex,
                      value: _ctx.field.value_attr,
                      isDisabled: _ctx.field.isDisabled,
                      onInputValue: _ctx.inputValue,
                      onBlur: _ctx.blurField
                    }, null, 8, ["placeholder", "style", "class", "tabindex", "value", "isDisabled", "onInputValue", "onBlur"]),
                    (!_ctx.field.isValid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(`validation.invalid_field`)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.field.field_type == `textarea`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_TextareaTag, {
                        placeholder: _ctx.field.placeholder_attr,
                        style: _normalizeStyle(_ctx.textareaStyle()),
                        class: _normalizeClass(`fl fs14 roundForm ${_ctx.field.isValid ? `` : `invalid `}`),
                        tabindex: _ctx.fieldindex,
                        value: _ctx.field.value_attr,
                        onInputValue: _ctx.inputValue,
                        onBlur: _ctx.blurField
                      }, null, 8, ["placeholder", "style", "class", "tabindex", "value", "onInputValue", "onBlur"]),
                      (!_ctx.field.isValid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t(`validation.invalid_field`)), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.field.field_type == `checkbox`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.selectable_values, (seldic, selindex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${seldic.value}_${selindex}`,
                            class: "fl mr17 mb6 mt5"
                          }, [
                            _createVNode(_component_CheckboxTag, {
                              value: seldic.value,
                              name: seldic.value,
                              checked: (_ctx.field.selected_values || []).includes(seldic.value),
                              prefix: `${_ctx.field.field_name}`,
                              onClickCheckbox: ($event: any) => (_ctx.clickCheckbox(_ctx.field, seldic.value)),
                              style: {"margin":"3px 5px 4px"}
                            }, null, 8, ["value", "name", "checked", "prefix", "onClickCheckbox"]),
                            _createElementVNode("label", {
                              for: `${_ctx.field.field_name}_${seldic.value}`,
                              class: "fs14"
                            }, _toDisplayString(seldic.value), 9, _hoisted_13)
                          ]))
                        }), 128)),
                        _hoisted_14,
                        (_ctx.field.allow_free_text)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_CheckboxTag, {
                                value: `その他`,
                                name: `その他`,
                                checked: (_ctx.field.selected_values || []).includes(`その他`),
                                prefix: `${_ctx.field.field_name}`,
                                onClickCheckbox: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickCheckbox(_ctx.field, `その他`))),
                                style: {"margin":"13px 5px 4px"},
                                class: "fl"
                              }, null, 8, ["checked", "prefix"]),
                              _createElementVNode("label", {
                                for: `${_ctx.field.field_name}_${`その他`}`,
                                class: "fl fs14 mt12"
                              }, _toDisplayString(`その他`), 8, _hoisted_16),
                              (_ctx.displayOtherField())
                                ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                                    key: 0,
                                    placeholder: `その他の内容を入力`,
                                    style: {"height":"50px"},
                                    class: _normalizeClass(`fl fs14 roundForm ml5 ${_ctx.field.isValid ? `` : `invalid`}`),
                                    tabindex: "-1",
                                    value: _ctx.field.value_attr,
                                    onInputValue: _ctx.inputOtherValue,
                                    onBlur: _ctx.blurField
                                  }, null, 8, ["class", "value", "onInputValue", "onBlur"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_17,
                        (!_ctx.field.isValid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.field.invalidText || _ctx.$t(`validation.invalid_field`)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.field.field_type == `select`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_SelectTag, {
                            name: "members_names",
                            id: "select_members_names",
                            class: "fl fs14 roundForm",
                            style: _normalizeStyle(_ctx.selectStyle()),
                            options: (_ctx.field.selectable_values || []).map(seldic => seldic.value),
                            defaultOption: 
                                _ctx.Util.isPresent(_ctx.field.selected_values)
                                    ? _ctx.field.selected_values[0]
                                    : _ctx.Util.isPresent(_ctx.field.default_selected_values)
                                    ? _ctx.field.default_selected_values
                                    : null
                            ,
                            needUnselect: true,
                            tabindex: _ctx.fieldindex,
                            onSelectValue: _ctx.selectFieldValue,
                            isDisabled: false,
                            height: _ctx.selectHeightStyle()
                          }, null, 8, ["style", "options", "defaultOption", "tabindex", "onSelectValue", "height"]),
                          _hoisted_20,
                          (_ctx.field.allow_free_text)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_ctx.displayOtherField())
                                  ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                                      key: 0,
                                      placeholder: `その他の内容を入力`,
                                      style: {"height":"50px"},
                                      class: _normalizeClass(`fl fs14 roundForm ${_ctx.field.isValid ? `` : `invalid`}`),
                                      tabindex: "-1",
                                      value: _ctx.field.value_attr,
                                      onInputValue: _ctx.inputOtherValue,
                                      onBlur: _ctx.blurField
                                    }, null, 8, ["class", "value", "onInputValue", "onBlur"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_22,
                          (!_ctx.field.isValid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.field.invalidText || _ctx.$t(`validation.invalid_field`)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_ctx.field.field_type == `radio`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createVNode(_component_RadioButtonTag, {
                              options: (_ctx.field.selectable_values || []).map(seldic => seldic.value),
                              optionName: _ctx.field.field_name,
                              defaultOption: 
                                _ctx.Util.isPresent(_ctx.field.selected_values)
                                    ? _ctx.field.selected_values[0]
                                    : _ctx.Util.isPresent(_ctx.field.default_selected_values)
                                    ? _ctx.field.default_selected_values
                                    : null
                            ,
                              type: `horizon`,
                              class: "mt10",
                              onSelect: _ctx.selectRadioValue
                            }, null, 8, ["options", "optionName", "defaultOption", "onSelect"]),
                            (_ctx.field.allow_free_text)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("fieldset", _hoisted_26, [
                                    _createElementVNode("span", _hoisted_27, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        value: `その他`,
                                        id: `${_ctx.field.field_name}_その他`,
                                        name: `${_ctx.field.field_name}`,
                                        checked: (_ctx.field.selected_values || []).includes(`その他`),
                                        style: {"width":"20px","-webkit-transform":"scale(1.5)","transform":"scale(1.5)","margin":"3px 5px 10px"},
                                        class: _normalizeClass(`fl a_radio pointer mr3`),
                                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickOther && _ctx.clickOther(...args)))
                                      }, null, 8, _hoisted_28),
                                      _createElementVNode("label", {
                                        class: "fl pointer",
                                        for: `${_ctx.field.field_name}_その他`
                                      }, " その他 ", 8, _hoisted_29)
                                    ]),
                                    (_ctx.displayOtherField())
                                      ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                                          key: 0,
                                          placeholder: `その他の内容を入力`,
                                          style: {"height":"50px"},
                                          class: _normalizeClass(`fl fs14 roundForm mw100 ${_ctx.field.isValid ? `` : `invalid`}`),
                                          tabindex: "-1",
                                          value: _ctx.field.value_attr,
                                          onInputValue: _ctx.inputOtherValue,
                                          onBlur: _ctx.blurField
                                        }, null, 8, ["class", "value", "onInputValue", "onBlur"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_30,
                            (!_ctx.field.isValid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.field.invalidText || _ctx.$t(`validation.invalid_field`)), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.field.field_type == `birthdate`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              (_ctx.birthdateOption && _ctx.birthdateOption.restrict_date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.birthdateStrictText), 1))
                                : _createCommentVNode("", true),
                              _createVNode(_component_SelectTag, {
                                name: "birthdate_year",
                                id: "select_birthdate_year",
                                class: "fl fs14 roundForm",
                                style: {"min-width":"40px","height":"50px","max-width":"120px"},
                                options: _ctx.birthdateYearOptions,
                                defaultOption: (_ctx.field.selected_values || []).length == 3 ? _ctx.field.selected_values[0] || null : null,
                                needUnselect: true,
                                tabindex: _ctx.fieldindex,
                                onSelectValue: _ctx.selectFieldValueYear,
                                isDisabled: false
                              }, null, 8, ["options", "defaultOption", "tabindex", "onSelectValue"]),
                              _hoisted_34,
                              _createVNode(_component_SelectTag, {
                                name: "birthdate_year",
                                id: "select_birthdate_year",
                                class: "fl fs14 roundForm",
                                style: {"min-width":"40px","height":"50px","max-width":"80px"},
                                options: _ctx.FormFieldCreator.selectMonths,
                                defaultOption: (_ctx.field.selected_values || []).length == 3 ? _ctx.field.selected_values[1] : null,
                                needUnselect: true,
                                tabindex: _ctx.fieldindex,
                                onSelectValue: _ctx.selectFieldValueMonth,
                                isDisabled: false
                              }, null, 8, ["options", "defaultOption", "tabindex", "onSelectValue"]),
                              _hoisted_35,
                              _createVNode(_component_SelectTag, {
                                name: "birthdate_year",
                                id: "select_birthdate_year",
                                class: "fl fs14 roundForm",
                                style: {"min-width":"40px","height":"50px","max-width":"80px"},
                                options: _ctx.Util.selectDaysStartOne,
                                defaultOption: (_ctx.field.selected_values || []).length == 3 ? _ctx.field.selected_values[2] : null,
                                needUnselect: true,
                                tabindex: _ctx.fieldindex,
                                onSelectValue: _ctx.selectFieldValueDay,
                                isDisabled: false
                              }, null, 8, ["options", "defaultOption", "tabindex", "onSelectValue"]),
                              _hoisted_36,
                              _hoisted_37,
                              (!_ctx.field.isValid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.field.invalidText || _ctx.$t(`validation.invalid_field`)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_ctx.field.field_type == `address`)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _hoisted_41,
                                  _createVNode(_component_TextfieldTag, {
                                    placeholder: `1000000`,
                                    type: `text`,
                                    pattern: "[0-9]*",
                                    style: {"height":"40px","min-width":"120px"},
                                    class: _normalizeClass(`fl fs14 roundForm ${_ctx.field.isValid ? `` : `invalid`}`),
                                    tabindex: _ctx.fieldindex,
                                    value: _ctx.field.value_attr,
                                    isDisabled: _ctx.field.isDisabled,
                                    max: "9999999",
                                    min: "0000000",
                                    onInputValue: _ctx.inputPostalCodeValue
                                  }, null, 8, ["class", "tabindex", "value", "isDisabled", "onInputValue"]),
                                  _hoisted_42
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                  _hoisted_44,
                                  _createVNode(_component_SelectTag, {
                                    name: "address",
                                    id: "select_address",
                                    class: "fl fs14 roundForm",
                                    style: {"min-width":"60px","height":"40px","padding":"3px"},
                                    options: _ctx.FormFieldCreator.getPrefeturesArray,
                                    defaultOption: _ctx.pref,
                                    needUnselect: false,
                                    tabindex: _ctx.fieldindex,
                                    onSelectValue: _ctx.selectPrefec,
                                    isDisabled: false
                                  }, null, 8, ["options", "defaultOption", "tabindex", "onSelectValue"]),
                                  _hoisted_45
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createVNode(_component_TextfieldTag, {
                                    placeholder: `○○市○○区`,
                                    style: {"height":"40px","min-width":"calc(100% - 180px)"},
                                    class: _normalizeClass(`fl fs14 roundForm ${_ctx.field.isValid ? `` : `invalid`}`),
                                    tabindex: _ctx.fieldindex,
                                    value: _ctx.address1,
                                    isDisabled: _ctx.field.isDisabled,
                                    onInputValue: _ctx.inputAddress1,
                                    onBlur: _ctx.blurField
                                  }, null, 8, ["class", "tabindex", "value", "isDisabled", "onInputValue", "onBlur"]),
                                  _hoisted_48
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _hoisted_50,
                                  _createVNode(_component_TextfieldTag, {
                                    placeholder: `○○マンション○階`,
                                    style: {"height":"40px","min-width":"calc(100% - 180px)"},
                                    class: _normalizeClass(`fl fs14 roundForm ${_ctx.field.isValid ? `` : `invalid`}`),
                                    tabindex: _ctx.fieldindex,
                                    value: _ctx.address2,
                                    isDisabled: _ctx.field.isDisabled,
                                    onInputValue: _ctx.inputAddress2,
                                    onBlur: _ctx.blurField
                                  }, null, 8, ["class", "tabindex", "value", "isDisabled", "onInputValue", "onBlur"]),
                                  _hoisted_51
                                ])
                              ]))
                            : (_ctx.field.field_type.includes(`head`))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w100", `${
                                _ctx.field.field_type == `head1` ? `fs36` : _ctx.field.field_type == `head2` ? `fs24` : ``
                            } fw800 ddgrey text-left mt20`])
                                  }, _toDisplayString(_ctx.field.field_name) + "   ", 3),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.field.description), 1),
                                    _createTextVNode("   ")
                                  ])
                                ]))
                              : (_ctx.field.field_type == `image1`)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    (_ctx.field.value_attr)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["w100", ``])
                                        }, [
                                          _createElementVNode("img", {
                                            src: _ctx.field.value_attr,
                                            style: {"width":"100%"}
                                          }, null, 8, _hoisted_55)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.field.field_type.includes(`upload_file`))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(`${_ctx.isDrag == `new` ? 'dragging lskyblueBg' : ``} centered w100 rad20 ${
                                !_ctx.field.isValid ? `roundForm invalid` : `borderGrey`
                            }`),
                                        onDragover: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', true)), ["prevent"])),
                                        onDragleave: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', false)), ["prevent"])),
                                        onDrop: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
                                        style: {"min-height":"80px","margin":"0px auto"}
                                      }, [
                                        (_ctx.uploading)
                                          ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
                                          : _createCommentVNode("", true),
                                        (_ctx.Util.isPresent(_ctx.field.userFile))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                              _createVNode(_component_UserFileImage, {
                                                file: _ctx.field.userFile,
                                                showDeleteButton: true,
                                                type: `form`,
                                                hideDownloadLink: true,
                                                onDeleted: _ctx.deletedAttachment
                                              }, null, 8, ["file", "onDeleted"]),
                                              _withDirectives(_createElementVNode("img", {
                                                class: "fr ml20 pointer",
                                                src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                                                width: "28",
                                                height: "30",
                                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deletedAttachment && _ctx.deletedAttachment(...args)))
                                              }, null, 8, _hoisted_58), [
                                                [_directive_tooltip, `削除`]
                                              ]),
                                              _hoisted_59
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                              _createElementVNode("label", _hoisted_61, [
                                                _createTextVNode(" ファイルを選択 "),
                                                _createElementVNode("input", {
                                                  type: "file",
                                                  class: "drop__input",
                                                  style: {"display":"none"},
                                                  id: "uploadText",
                                                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
                                                }, null, 32)
                                              ]),
                                              _hoisted_62,
                                              _hoisted_63
                                            ]))
                                      ], 34),
                                      (!_ctx.field.isValid)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.field.invalidText), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : ([`radio_image`, `checkbox_image`].includes(_ctx.field.field_type))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Util.splitArray(_ctx.field.selectable_values, 2), (selarr, selindex) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "centering",
                                            style: {"justify-content":"space-around"},
                                            key: `${selindex}`
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selarr, (seldic, selindex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: _normalizeClass(`ddgrey text-left mt20 mb10 posRe rad5 SelectImageContent
                                     ${
                                         _ctx.field.selected_values.includes(seldic.value)
                                             ? _ctx.isSP
                                                 ? `pad0 selected`
                                                 : `pad5 selected`
                                             : _ctx.isSP
                                             ? `pad5`
                                             : `pad10`
                                     }`),
                                                style: _normalizeStyle({
                                    width: _ctx.isSP ? `142px` : `240px`,
                                }),
                                                key: `${selindex}`,
                                                onClick: ($event: any) => (_ctx.selectImage(seldic.value))
                                              }, [
                                                (_ctx.Util.isPresent(seldic.image_url))
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      style: _normalizeStyle(_ctx.imageSizeDic),
                                                      class: "centering pointer"
                                                    }, [
                                                      _createElementVNode("img", {
                                                        src: seldic.image_url,
                                                        style: _normalizeStyle(Object.assign(_ctx.imageSizeDic, { top: 0, left: 0, right: 0, bottom: 0 }))
                                                      }, null, 12, _hoisted_67)
                                                    ], 4))
                                                  : (_openBlock(), _createElementBlock("div", {
                                                      key: 1,
                                                      style: _normalizeStyle(_ctx.imageSizeDic)
                                                    }, [
                                                      _createElementVNode("img", {
                                                        src: _ctx.$getAssetImageUrl(`/assets/icons/image_nil.png`),
                                                        class: "w100"
                                                      }, null, 8, _hoisted_68)
                                                    ], 4)),
                                                _hoisted_69,
                                                _createElementVNode("div", _hoisted_70, _toDisplayString(seldic.value) + "  ", 1),
                                                _hoisted_71
                                              ], 14, _hoisted_66))
                                            }), 128)),
                                            _hoisted_72
                                          ]))
                                        }), 128)),
                                        (!_ctx.field.isValid)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_ctx.field.invalidText), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
              _hoisted_74
            ], 2),
            _hoisted_75
          ], 4),
          (_ctx.editable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  (_ctx.fieldindex != 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.$getAssetImageUrl(`/assets/icons/ar_up.png`),
                        width: "24",
                        height: "24",
                        class: "pointer mb20",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clickUp && _ctx.clickUp(...args)))
                      }, null, 8, _hoisted_78))
                    : (_openBlock(), _createElementBlock("div", _hoisted_79)),
                  _hoisted_80,
                  (_ctx.fieldindex != _ctx.total - 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 2,
                        src: _ctx.$getAssetImageUrl(`/assets/icons/ar_down.png`),
                        width: "24",
                        height: "24",
                        class: "pointer mt20",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clickDown && _ctx.clickDown(...args)))
                      }, null, 8, _hoisted_81))
                    : _createCommentVNode("", true),
                  _hoisted_82
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    (_ctx.field.canDelete)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                          width: "20",
                          height: "23",
                          class: "pointer fl mr15",
                          id: `_fieldof${_ctx.fieldindex}`,
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removeField && _ctx.removeField(...args)))
                        }, null, 8, _hoisted_85))
                      : (_openBlock(), _createElementBlock("div", _hoisted_86, " ")),
                    (_ctx.field.canDelete)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: _ctx.$getAssetImageUrl(`/assets/icons/copy_icon.png`),
                          width: "20",
                          height: "23",
                          class: "pointer fl mr15",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.copyField && _ctx.copyField(...args)))
                        }, null, 8, _hoisted_87)), [
                          [
                            _directive_tooltip,
                            `複製`,
                            void 0,
                            { top: true }
                          ]
                        ])
                      : (_openBlock(), _createElementBlock("div", _hoisted_88, " ")),
                    (_ctx.field.is_special)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 4,
                          src: _ctx.$getAssetImageUrl(`/assets/icons/asta.png`),
                          width: "20",
                          height: "23",
                          class: "pointer fl mr15"
                        }, null, 8, _hoisted_89)), [
                          [
                            _directive_tooltip,
                            
                                `特殊フィールド\n\nこちらは「${_ctx.field.special_name}」のための特殊フィールドです。\n違う趣旨のものをいれないようご注意ください。`
                            ,
                            void 0,
                            { top: true }
                          ]
                        ])
                      : (_openBlock(), _createElementBlock("div", _hoisted_90, " "))
                  ]),
                  _hoisted_91,
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_92, [
                    _createTextVNode(" <<フォーム回答-" + _toDisplayString((_ctx.fieldindex || 0) + 1) + ">> ", 1)
                  ])), [
                    [_directive_tooltip, `イベント登録用変数名`]
                  ]),
                  _hoisted_93
                ]),
                _hoisted_94
              ]))
            : _createCommentVNode("", true),
          _hoisted_95
        ]),
        _hoisted_96,
        (_ctx.editable)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`additionalField ${_ctx.editable ? `withEditable` : ``} posRe w100 mt20`),
              style: {"height":"30px"},
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addNewField && _ctx.addNewField(...args)))
            }, _hoisted_98, 2))
          : _createCommentVNode("", true),
        _hoisted_99
      ]))
    : _createCommentVNode("", true)
}